import React from 'react';
import PropTypes from 'prop-types';
import DialogContent from '@mui/material/DialogContent';

export const VpDialogContent = ({ disablePadding, sx, children, ...rest }) => {
  const disabledPadding = {
    padding: '0px !important'
  };
  const styles = {
    ...(disablePadding ? disabledPadding : {}),
    ...sx
  };

  return (
    <DialogContent sx={styles} {...rest}>
      {children}
    </DialogContent>
  );
};

VpDialogContent.propTypes = {
  sx: PropTypes.shape({}),
  disablePadding: PropTypes.bool,
  children: PropTypes.node
};

export default VpDialogContent;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpDialogContent/VpDialogContent.jsx